import React, {useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';

//CSS
import styles from './VTPrices.module.less';

//ICONS
import icon from "../../../../assets/img/persons.png";

function Prices({price, bookedPax, removePerson, addPerson, i18n}) {
  return (
    <div className={styles.price}>
        <span className={styles.name}>
          {price.name[i18n.language] ? price.name[i18n.language]:price.name['es']}
          <span className="h-margin-l-10"> ({price.price} €)</span>
        </span>
        <div className={styles.controls} >
        <div className={styles.buttonMinus} onClick={()=>removePerson(price.id)}>&#8722;</div>
          <input className={styles.persons} value={bookedPax[price.id]} readOnly/>
        <div className={styles.buttonPlus} onClick={()=>addPerson(price.id)}>+</div>
      </div>
    </div>
  );
}

function VTPrices({excursionsPrices, bookedPax, availability, excursionDeparture, paxMax, getTotalPax, updatePaxs, showError}) {
  const {t,i18n} = useTranslation("vtform");
  const pricesContentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [seletedNamePrices, setSeletedNamePrices] = useState(t("vtprices.Personas"));

  //--------------------------------------------------------------------------------------------------------------------
  function getFormPax(){
    let totalPax=0;

    //Comprobamos primero que existen los objetos necesarios
    if (bookedPax !== null && excursionsPrices !== null){
      for (const idprice in bookedPax){
        const price = excursionsPrices.find(price => price.id===idprice);
        if (!price.supplement) totalPax+=bookedPax[idprice];
      }
    }
    return totalPax;
  }

  //--------------------------------------------------------------------------------------------------------------------
  function toggle(event) {
    if (pricesContentRef.current) {
      if (pricesContentRef.current.contains(event.target) && isOpen) return;
      setIsOpen((isOpen) => !isOpen);
    }
  }

  const handleClickOutside = (event) => {
    if (pricesContentRef.current) {
      if (pricesContentRef.current.contains(event.target)) return;
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    if (getFormPax() == 0) setSeletedNamePrices(t('vtprices.Personas'));
    else {
      let pricename="";
      for (const idprice in bookedPax){
        const price = excursionsPrices.find(price => price.id===idprice);
        if (bookedPax[idprice] > 0) pricename += price.name[i18n.language] + " x " + bookedPax[idprice] + " ";
      }
      setSeletedNamePrices(pricename);
    }

  }, [excursionsPrices, bookedPax]);

  function addPerson(idprice){
    const newPax ={...bookedPax};
    const quotafree = excursionDeparture != null ? availability[excursionDeparture]: paxMax;
    const price = excursionsPrices.find(price => price.id===idprice);

    if (price.supplement){
      newPax[idprice]++;
    }else{
      if (getTotalPax() < quotafree) newPax[idprice]++;
      else showError([{sticky: true, severity: 'warn', summary: 'Warning', detail: '[ef024] No ha mas plazas libres' }]);
    }
    updatePaxs(newPax);
  }

  function removePerson(idprice){
    const newPax ={...bookedPax};
    if (newPax[idprice] > 1) newPax[idprice]--;
    else newPax[idprice]=0;
    updatePaxs(newPax);
    showError([]);
  }

  let listPrices = null;
  if (excursionsPrices != null){
    listPrices = Object.keys(excursionsPrices).map(row =>{
      return <Prices key={excursionsPrices[row].id} price={excursionsPrices[row]} bookedPax={bookedPax} removePerson={removePerson} addPerson={addPerson} i18n={i18n}/>;
    });
  }

  return (
    <div ref={pricesContentRef} className={styles.vtprices} onClick={toggle}>
      <div className={styles.text}>
        <img className={styles.icon} src={icon}/>
        {seletedNamePrices}
      </div>
      {isOpen &&
        <div className={styles.pricesmodal} >
          {excursionsPrices ?
            listPrices
          :
            t("vtprices.Debe seleccionar la fecha primero")
          }
        </div>
      }
    </div>
  );
}

export default VTPrices;
